module.exports = __webpack_public_path__ + "img/link.fdda6751.svg";